'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashCompat = require('lodash-compat');

var _index = require('../../index');

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _data = require('../../util/data');

var _nodata = require('../img/nodata.png');

var _nodata2 = _interopRequireDefault(_nodata);

var _util3 = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 时间轴组件(使用 Tabs)
 *  显示时间和节点描述
 */
var Timeline = (_temp = _class = function (_M$BaseComponent) {
  _inherits(Timeline, _M$BaseComponent);

  function Timeline(props) {
    _classCallCheck(this, Timeline);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Timeline).call(this, props));

    _this.model = Object.assign({}, _util3.MODEL, props.model);
    _this.state = {
      loading: true,
      list: [],
      data: null, // 存储渲染内容的数据
      active: props.active ? Object.assign({}, props.active, _defineProperty({}, _util3.IDFIELD, (0, _util3.getKey)(_this.model, props.active))) : {}
    };
    return _this;
  }

  _createClass(Timeline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      return new Promise(function ($return, $error) {
        function $IfStatement_5() {
          return $return();
        }

        if ('active' in nextProps && nextProps.active !== this.props.active) {
          return Promise.resolve(this.fetchDetail(Object.assign({}, nextProps.active, _defineProperty({}, _util3.IDFIELD, (0, _util3.getKey)(this.model, nextProps.active))))).then(function ($await_6) {
            return $IfStatement_5.call(this);
          }.$asyncbind(this, $error), $error);
        }
        return $IfStatement_5.call(this);
      }.$asyncbind(this));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this.fetchTimeline()).then(function ($await_7) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(item, index) {
      var _M$classNames, _M$classNames2;

      var _props = this.props;
      var renderLabel = _props.renderLabel;
      var prefixCls = _props.prefixCls;
      var color = _props.color;
      var simple = _props.simple;
      var _model = this.model;
      var leftField = _model.leftField;
      var rightField = _model.rightField;
      var colorField = _model.colorField;

      var desc = item[rightField];
      var label = item._new ? item[leftField] : _util2.default.formatDatetime(item[leftField] || '', '%Y-%m-%d');
      var content = {
        left: label || '',
        right: desc || ''
      };
      var _state = this.state;
      var active = _state.active;
      var list = _state.list;

      if (!item._new && renderLabel && (0, _data.isFunction)(renderLabel)) {
        var res = renderLabel({ item: item, index: index, list: list });
        if ((0, _react.isValidElement)(res)) {
          return res;
        } else if ((0, _data.isObject)(res)) {
          // 如果是返回了 left, right 的对象
          if ('left' in res) {
            leftField = true;
          }
          if ('right' in res) {
            rightField = true;
          }
          Object.assign(content, res);
        }
      }
      prefixCls += '-timeline-label';
      var cls = _util2.default.classNames((_M$classNames = {}, _defineProperty(_M$classNames, '' + prefixCls, true), _defineProperty(_M$classNames, '_' + item[_util3.IDFIELD], true), _M$classNames));
      var itemColor = item[colorField] || (!simple && active[_util3.IDFIELD] === item[_util3.IDFIELD] ? "primary" : color);
      var headCls = _util2.default.classNames((_M$classNames2 = {}, _defineProperty(_M$classNames2, prefixCls + '_head', true), _defineProperty(_M$classNames2, prefixCls + '_head_' + itemColor, itemColor), _defineProperty(_M$classNames2, prefixCls + '_head_custom', content.dot), _M$classNames2));
      return _react2.default.createElement(
        'div',
        { className: cls },
        leftField && _react2.default.createElement(
          'div',
          { className: prefixCls + '_left' },
          content.left || ''
        ),
        _react2.default.createElement(
          'div',
          { className: headCls },
          (0, _data.isString)(content.dot) ? _react2.default.createElement(_index.Icon, { type: content.dot }) : content.dot
        ),
        rightField && _react2.default.createElement(
          'div',
          { className: prefixCls + '_right' },
          content.right || ''
        )
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent(item, index) {
      var renderContent = this.props.renderContent;
      var _state2 = this.state;
      var active = _state2.active;
      var data = _state2.data;
      var list = _state2.list;

      if (renderContent && (0, _data.isFunction)(renderContent) && item[_util3.IDFIELD] === active[_util3.IDFIELD]) {
        return renderContent({ data: data, item: item, index: index, list: list });
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props2 = this.props;
      var prefixCls = _props2.prefixCls;
      var hideAdd = _props2.hideAdd;
      var addBtnConf = _props2.addBtnConf;
      var extraTab = _props2.extraTab;
      var position = _props2.position;
      var simple = _props2.simple;
      var other = _props2.other;

      prefixCls += '-timeline';
      var _state3 = this.state;
      var active = _state3.active;
      var list = _state3.list;
      var loading = _state3.loading;

      var cls = this.classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, prefixCls + '_showRight', this.model.rightField), _defineProperty(_classNames, prefixCls + '_simple', simple), _classNames));
      if (!list || list.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: prefixCls + ' ' + prefixCls + '-noData', ref: 'container' },
          loading && _react2.default.createElement(_index.Spin, null),
          _react2.default.createElement('img', { src: _nodata2.default }),
          _react2.default.createElement(
            'p',
            null,
            '暂无数据'
          )
        );
      }
      var showAdd = !hideAdd && !(0, _util3.hasNew)(list);
      var extraTabDOM = !simple && _react2.default.createElement(
        'div',
        { className: prefixCls + '__extra ' + (showAdd || extraTab ? '' : prefixCls + '__extra-noData') },
        extraTab,
        showAdd && _react2.default.createElement(_index.Button, _extends({ className: prefixCls + '__extra-add',
          onClick: this._addHandler }, Object.assign(_util3.ADDBTNCONF, addBtnConf)))
      );
      return _react2.default.createElement(
        'div',
        { className: cls },
        loading && _react2.default.createElement(_index.Spin, null),
        _react2.default.createElement(_index.Tabs, _extends({}, other, { position: position,
          autoDestory: true,
          height: '100%',
          showPage: false,
          disabled: simple,
          model: { idField: _util3.IDFIELD },
          activeKey: active[_util3.IDFIELD],
          value: list.map(function (item, index) {
            item.label = _this2.renderLabel(item, index);
            item.content = !simple && _this2.renderContent(item, index);
            return item;
          }),
          extraTab: extraTabDOM,
          onChange: this._changeHandler }))
      );
    }

    // 选中哪条

  }, {
    key: '_getActiveHandler',
    value: function _getActiveHandler(list) {
      if (!Array.isArray(list) || list.length <= 0) {
        return;
      }
      var getActive = this.props.getActive;
      var active = this.state.active;
      // 当前没有指定选中的时候, 选中第一项

      if (getActive) {
        active = getActive(list);
      } else if (!([_util3.IDFIELD] in active) || !(0, _util3.findItem)(list, active[_util3.IDFIELD])) {
        active = list[0];
      }
      return active;
    }
    // 新增时间版本

  }, {
    key: '_addHandler',
    value: function _addHandler() {
      return new Promise(function ($return, $error) {
        var onAdd = this.props.onAdd;
        var _state4 = this.state;
        var list = _state4.list;
        var active = _state4.active;
        var data = _state4.data;

        var oldList = (0, _lodashCompat.cloneDeep)(list);
        var newDate = (0, _util3.getNewTime)(this.model);
        var index = !([_util3.IDFIELD] in active) ? 0 : (list || []).findIndex(function (v) {
          return v[_util3.IDFIELD] === active[_util3.IDFIELD];
        });
        if (index !== -1) {
          list.splice(index, 0, newDate);
          Object.assign(this.state, { list: list });
        }
        return Promise.resolve(onAdd({ active: active, newDate: newDate, list: oldList, data: data })).then(function ($await_8) {
          var res = $await_8;
          if (res === false) return $return();
          if (index !== -1 && !(0, _util3.hasNew)(oldList)) {
            list.splice(index, 1, newDate);
            this.addData = (0, _data.isEmptyString)(res) ? data : res;
            this.setState({ active: newDate, list: list, data: this.addData });
          }
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
    // 切换时间轴

  }, {
    key: '_changeHandler',
    value: function _changeHandler(key) {
      return new Promise(function ($return, $error) {
        var _props3 = this.props;
        var onSelect = _props3.onSelect;
        var delNewWhenSelect = _props3.delNewWhenSelect;
        var _state5 = this.state;
        var active = _state5.active;
        var list = _state5.list;

        var selected = (0, _util3.findItem)(list, key);
        return Promise.resolve(onSelect({ active: active, selected: selected, list: list })).then(function ($await_9) {
          var res = $await_9;
          if (res === false) return $return();
          if (active._new && delNewWhenSelect) {
            // 删除新增中节点
            var index = (list || []).findIndex(function (v) {
              return v[_util3.IDFIELD] === active[_util3.IDFIELD];
            });
            index !== -1 && list.splice(index, 1);
            Object.assign(this.state, { list: list });
          }
          if (selected._new) {
            // 跳到新增中去
            this.setState({ active: selected, data: this.addData });
          } else if (!('active' in this.props)) {
            this.fetchDetail(selected);
          }
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }

    // 请求左侧时间轴数据

  }, {
    key: 'fetchTimeline',
    value: function fetchTimeline() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new Promise(function ($return, $error) {
        var _this3 = this;

        var list = [];
        var _props4 = this.props;
        var onFetchTimeline = _props4.onFetchTimeline;
        var initIfEmpty = _props4.initIfEmpty;
        var simple = _props4.simple;
        var hideAdd = _props4.hideAdd;

        this.setState({ loading: true }, function () {
          return new Promise(function ($return, $error) {
            var $Try_1_Finally = function ($Try_1_Exit) {
              return function ($Try_1_Value) {
                var active = void 0;
                Object.assign(this.state, { list: list });
                if (!simple && list.length === 0 && !hideAdd && initIfEmpty) {
                  Object.assign(this.state, { active: {}, data: null }); // 如果是传入的空数组, 那么置空
                  this._addHandler();
                  this.setState({ loading: false });
                } else {
                  active = this._getActiveHandler(list); // 当前没有指定选中的时候, 选中第一项
                  if (active) {
                    this.fetchDetail(active);
                  } else {
                    this.setState({ loading: false });
                  }
                }
                return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
              }.$asyncbind(this, $error);
            }.$asyncbind(this);

            var $Try_1_Catch = function ($exception_2) {
              return $Try_1_Finally($error)($exception_2);
            }.$asyncbind(this, $Try_1_Finally($error));

            function $Try_1_Post() {
              return $return();
            }

            try {
              return Promise.resolve(onFetchTimeline.apply(undefined, args)).then(function ($await_10) {
                list = $await_10 || [];
                list = (0, _util3.buildTimeline)(this.model, Array.isArray(list) ? list : list.pageList || []);
                return $Try_1_Finally($Try_1_Post).call(this);
              }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
            } catch ($exception_2) {
              $Try_1_Catch($exception_2)
            }
          }.$asyncbind(_this3));
        });
        return $return();
      }.$asyncbind(this));
    }
    // 请求右侧内容数据

  }, {
    key: 'fetchDetail',
    value: function fetchDetail(active) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return new Promise(function ($return, $error) {
        var _this4 = this;

        var stateActive = this.state.active;

        active = [_util3.IDFIELD] in active ? active : stateActive;
        if (active) {
          (function () {
            var data = {};
            _this4.setState({ loading: true }, function () {
              return new Promise(function ($return, $error) {
                var $Try_3_Finally = function ($Try_3_Exit) {
                  return function ($Try_3_Value) {
                    // Tabs 根据 active 选中页签后直接渲染内容, 此时 state.data 必须要有值
                    this.setState({ loading: false, active: active, data: data });
                    return $Try_3_Exit && $Try_3_Exit.call(this, $Try_3_Value);
                  }.$asyncbind(this, $error);
                }.$asyncbind(this);

                var $Try_3_Catch = function ($exception_4) {
                  return $Try_3_Finally($error)($exception_4);
                }.$asyncbind(this, $Try_3_Finally($error));

                function $Try_3_Post() {
                  return $return();
                }

                try {
                  var _props5;

                  return Promise.resolve((_props5 = this.props).onFetchDetail.apply(_props5, [active].concat(args))).then(function ($await_11) {
                    data = $await_11;
                    return $Try_3_Finally($Try_3_Post).call(this);
                  }.$asyncbind(this, $Try_3_Catch), $Try_3_Catch);
                } catch ($exception_4) {
                  $Try_3_Catch($exception_4)
                }
              }.$asyncbind(_this4));
            });
          })();
        }
        return $return();
      }.$asyncbind(this));
    }
    // 设置左侧时间轴数据

  }, {
    key: 'setTimeline',
    value: function setTimeline(source) {
      return new Promise(function ($return, $error) {
        if (Array.isArray(source)) {
          var list = (0, _util3.buildTimeline)(this.model, (0, _lodashCompat.cloneDeep)(source));
          Object.assign(this.state, { list: list });
          var active = this._getActiveHandler(list);
          if (active) {
            this.fetchDetail(active);
          } else {
            this.forceUpdate();
          }
        }
        return $return();
      }.$asyncbind(this));
    }

    // 获取左侧时间轴数据

  }, {
    key: 'getTimeline',
    value: function getTimeline() {
      return this.state.list;
    }
    // 获取当前选中的时间节点

  }, {
    key: 'getActive',
    value: function getActive() {
      return this.state.active;
    }
  }]);

  return Timeline;
}(_util2.default.BaseComponent), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  position: _propTypes2.default.oneOf(['left', 'right']),
  hideAdd: _propTypes2.default.bool,
  initIfEmpty: _propTypes2.default.bool,
  delNewWhenSelect: _propTypes2.default.bool,
  addBtnConf: _propTypes2.default.object,
  extraTab: _propTypes2.default.node,
  model: _propTypes2.default.shape({
    idField: _propTypes2.default.string,
    leftField: _propTypes2.default.string,
    colorField: _propTypes2.default.string,
    rightField: _propTypes2.default.string
  }),
  simple: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  active: _propTypes2.default.object,
  getActive: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  onFetchTimeline: _propTypes2.default.func,
  onFetchDetail: _propTypes2.default.func,
  renderLabel: _propTypes2.default.func,
  renderContent: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: "mt", // 样式前缀
  position: 'left', // 时间轴位于内容的哪端
  hideAdd: false, // 是否隐藏 '新增' 按钮
  initIfEmpty: true, // 没有时间节点时, 是否显示新增中
  delNewWhenSelect: false, // 当从新增中切换到其他节点时, 是否删除新增中
  addBtnConf: null, // '新增' 按钮的配置, 直接传给 Button 的属性, 例如 { icon: "", size: "" }
  extraTab: null, // 是否有额外的内容显示在时间轴之上
  model: null, // 设置时间轴的显示模板 {leftField, rightField, idField... }
  simple: false, // 设置简单模式
  color: 'default', // 设置整体的颜色
  getActive: null, // 判断应该选中的时间节点并返回  getActive(list) { return active }
  onSelect: _data.noop, // 切换时间版本时的回调
  onAdd: _data.noop, // 点击 '新增' 按钮的回调
  onFetchTimeline: _data.noop, // 获取时间节点数组的方法 onFetchTimeline() { return array };
  onFetchDetail: _data.noop, // 获取某个时间节点对应详细数据的方法 onFetchDetail(active) { return anyType }
  renderLabel: null, // 渲染时间节点的方法 renderLabel({item, index, list}) { return {left: "2017-07-01", right: "系统生成"} || <div></div>  }
  renderContent: null }, _temp);
exports.default = Timeline;